import { FC } from "react";
import {
  LEGAL_EFFECTIVE_DATE,
  LEGAL_LAST_UPDATED,
} from "../../lib/legalDocuments";

const LegalDocumentDates: FC = () => (
  <dl className="mb-6 flex flex-wrap justify-center gap-x-8 gap-y-1 text-sm">
    <div className="flex gap-2">
      <dt className="font-semibold">Effective date:</dt>
      <dd>{LEGAL_EFFECTIVE_DATE}</dd>
    </div>
    <div className="flex gap-2">
      <dt className="font-semibold">Last updated:</dt>
      <dd>{LEGAL_LAST_UPDATED}</dd>
    </div>
  </dl>
);

export default LegalDocumentDates;
